export default __webpack_public_path__ + "fonts/color_pro_logo.bd9ad4a6c8b6fccc0be24a90a65186fe.png";